<template>
    <div class="aboutPage">
        <div class="top"></div>
        <div class="header">
            <router-link to="/home/usercenter" tag="i"> <img src="./../../../../assets/home/back.jpg" alt=""> </router-link>
            <span>关于我们</span>
        </div>
        <div class="content">
            <div class="x-man"><img src="./../../../../assets/usercenter/xman-about.png" alt=""></div>
            <p class="text">i红包</p>
            <p class="version">Version 1.1.1</p>
        </div>
        <div class="footerBox">
            <span class="web">官方网站</span>
            <div class="imgBox"><img src="./../../../../assets/usercenter/arrow.png" alt=""></div>
        </div>
    </div>
</template>

<script>
export default {

}
</script>

<style lang="scss" scoped>
    .top{
        height:.2rem;
    }
    .header{
        width:90%;
        height:.40rem;
        margin-left: 5%;
        display: flex;
        justify-content: center;
        align-items: center;
        position:relative;
        span{
            font-size: .18rem;
            line-height: .40rem;
        }
        i{
            position:absolute;
            left:0.05rem;
            width:.26rem;
            height:.16rem;
            padding-right:.16rem;
        }
    }
    .content{
        width:100%;
        display:flex;
        align-items: center;
        flex-direction: column;
        .x-man{
            width:.90rem;
            height:1.15rem;
            padding-top:.25rem;
        }
        .text{
            color:#333333;
            font-size: .24rem;
            padding-top:.10rem;
        }
        .version{
            color:#4A4A4A;
            font-size: .12rem;
        }
        
    }
    .footerBox{
        width:90%;
        height:.46rem;
        margin:0 auto;
        display:flex;
        justify-content: space-between;
        align-items: center;
        border-bottom:.01rem solid #CCCCCC;
        margin-top:1.00rem;
        .web{
            font-size: .14rem;
            color:#555555;
        }
        .imgBox{
            width:.08rem;
            height:.14rem;
        }
    }
</style>

